// extracted by mini-css-extract-plugin
export default {"container":"TablePriceCell_container__hM-oX"};